import { types } from "../types/types";
const intitalState = {
    allUsers: []
};

const usersReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.USERS:
            return {
                ...state,
                allUsers: action.payload,
            };
        default:
            return { ...state };
    }
};

export default usersReducer;
